export default {
  production: {
    topLevelDomain: 'com',
    protocol: 'https'
  },
  staging: {
    topLevelDomain: 'cn',
    protocol: 'https'
  },
  test: {
    topLevelDomain: 'test',
    protocol: 'http'
  }
};
